import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class RoadmapStrategyRoadmapLensRoute extends Route {
  @service router;
  @service roadmap;

  beforeModel() {
    const model = this.modelFor('roadmap.strategy.roadmap');
    this.roadmap.setId(model.id);
    this.router.transitionTo('planning.dashboard.lanes');
  }
}
